import React from 'react';
import PropTypes from 'prop-types';
import { AskRamsey } from '@ramsey-plus/ask-ramsey-ui';
import '@ramsey-plus/ask-ramsey-ui/dist/style.css';
import Rails from '@rails/ujs';

// eslint-disable-next-line no-unused-vars
const AskRamseyContainer = ({ userId, riveFile }) => {
  return (
    <AskRamsey
      user_id={userId}
      application_name={'ramsey-plus'}
      base_url={'/app/ask'}
      titleOverride={'Suggested Clip (Beta)'}
      // thumbsDownRivePath={riveFile}
      // thumbsUpRivePath={riveFile}
      csrfToken={Rails.csrfToken()}
    />
  );
};

AskRamseyContainer.propTypes = {
  userId: PropTypes.string,
  riveFile: PropTypes.string
};
export default AskRamseyContainer;
